import { AppRoutes } from "@/constants/routes";
import { toaster } from "@/components/ui/toaster";
import { getAxiosErrorMessage } from "@/utils/axios-error-message";
import { handlePermissionError } from "@/utils/permission-check";
import { getNotificationTypes } from "@/services/notification-types.service";
import { AxiosError } from "axios";
import { NavigateFunction } from "react-router-dom";
import type { NotificationTypeListItem } from "@/services/notification-types.service";

interface FetchNotificationTypesHandlerArgs {
  setLoading: (v: boolean) => void;
  setItems: (v: NotificationTypeListItem[] | null) => void;
  navigate: NavigateFunction;
  fetchPermissions?: () => Promise<void>;
  showLoad?: boolean;
  routeState?: any;
}

export const fetchNotificationTypesHandler = async ({
  setLoading,
  setItems,
  navigate,
  fetchPermissions,
  showLoad = true,
  routeState,
}: FetchNotificationTypesHandlerArgs) => {
  try {
    if (showLoad) setLoading(true);

    const response = await getNotificationTypes();
    setItems(response ?? null);
  } catch (error) {
    const errorObj = error as AxiosError;

    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
      AppRoutes.NOTIFICATIONS,
      routeState,
    );

    if (!handled) {
      toaster.create({
        type: "error",
        title: getAxiosErrorMessage(errorObj, "No se pudo cargar el listado."),
      });
    }

    throw error;
  } finally {
    if (showLoad) setLoading(false);
  }
};
